import { DataTable } from "@/src/components/ui/data-table";
import { useEffect, useMemo, useState } from "react";
import { useSorting } from "./state";
import { Offer } from "./model";
import { offersColumns } from "./offersColumns";
import { useOffersStore } from "../../stores/offersStore";
import qs from "qs";
import { fetch } from "../../lib/fetch";
import { useNavigate } from "react-router-dom";

type SearchPagination = {
  total: number;
  pagination: {
    page: number;
    pageSize: number;
  };
};

type OffersData = {
  data: Offer[];
} & SearchPagination;

export function OffersTable() {
  const [loading, setLoading] = useState(false);
  const [offers, setOffers] = useState<OffersData>({
    data: [],
    total: 1,
    pagination: {
      page: 1,
      pageSize: 10,
    },
  });
  const [page, setPage] = useState(1);
  const sort = useSorting();
  const { filters } = useOffersStore();

  const navigate = useNavigate();

  const preparedFilters = useMemo(() => {
    return prepareFilters(filters);
  }, [filters]);

  const query = qs.stringify(preparedFilters, { indices: false });

  const fetchOffers = (page: number) =>
    fetch<{ data: Offer[] } & SearchPagination>(
      `/api/offers?page=${page}&pageSize=10${query ? "&" + query : query}&sort=${sort}`,
    );

  useEffect(() => {
    setLoading(true);
    fetchOffers(page).then((data) => {
      setOffers(data);
      setLoading(false);
    });
  }, [page, query, sort]);

  return (
    <div className="rounded-md bg-white border overflow-hidden">
      <DataTable
        columns={offersColumns}
        data={offers.data}
        onRowClick={(r) => navigate(`/offers/${r.id}`)}
        isLoading={loading}
        pagination={{
          pagination: {
            page: +offers.pagination.page,
            pageSize: +offers.pagination.pageSize,
          },
          total: offers.total,
        }}
        onPageClick={(page) => {
          setPage(page);
        }}
      />
    </div>
  );
}

function prepareFilters(filters: any) {
  const preparedFilters = { ...filters };
  if (preparedFilters.customer) {
    preparedFilters.customerEmail = preparedFilters.customer.email;
    delete preparedFilters.customer;
  }
  if (preparedFilters.broker) {
    preparedFilters.broker = preparedFilters.broker.id;
  }

  return preparedFilters;
}
